import Camp from './Camp'
import Carousel from '../../../../common/js/Carousel'
import bentiuMap from './camps/bentiu/mapb'
import alHolMap from './camps/al-hol/mapb'
import kutapalongMap from './camps/kutapalong/mapb'


export default class CampsSlide extends Carousel {
  initializeSlides() {
    return {
      1: this.initializeBentiuCamp(),
      2: this.initializeAlHolCamp(),
      3: this.initializeKutapalongCamp(),
    }
  }

  initializeBentiuCamp() {
    return new Camp(this.$el.querySelector('.camp-1'), bentiuMap)
  }

  initializeAlHolCamp() {
    return new Camp(this.$el.querySelector('.camp-2'), alHolMap)
  }

  initializeKutapalongCamp() {
    return new Camp(this.$el.querySelector('.camp-3'), kutapalongMap)
  }
}